import { Center } from '@chakra-ui/react';
import React from 'react';

import { LoaderDots } from '../loader-dots';

/**
 * An alignment wrapper for the LoaderDots view.
 */
export const LoadingView = () => {
    return (
        <Center
            data-testid={'loading-view-test-id'}
            w={'100%'}
            h={'100%'}
            position={'absolute'}
            top={0}
            bgColor={'rgba(0, 0 , 0, 0.2)'}
        >
            <LoaderDots />
        </Center>
    );
};
